import styled from 'styled-components'
import { v1 as color } from 'sidecar-design-library'

export const Amount = styled.span`
  margin: 0 0 0 auto;
`

export const Bullet = styled.span`
  margin: 0 0.1875rem;
`

export const Link = styled.span`
  font-size: 0.75rem;
  line-height: 1.25rem;
  color: ${color.AQUAMARINE};
  cursor: pointer;

  &:hover {
    color: ${color.SCOOTER};
  }
`

export const Row = styled.div`
  display: flex;
`
